import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// Include call API
import { getMapAPI } from "../../../api/map";
import { getMapError, getMapSuccess } from "./actions";
// Login Redux States
import { GET_MAP } from "./actionTypes";



const mapAPI = getMapAPI();

function* getAllMap({ payload: { user, size, page, search, type, status } }) {

  try {

    const response = yield call(mapAPI.getMap, user.token, size, page, search, type, status);
    yield put(getMapSuccess(response.paginator, response.message));
  } catch (error) {

    yield put(getMapError(error));
  }
}

export function* watchGetMap() {
  yield takeEvery(GET_MAP, getAllMap);
}

function* getMapSaga() {
  yield all([fork(watchGetMap)]);
}

export default getMapSaga;
